<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'serv-formulario') {
            next({ name: 'serv-formulario-list' });
        } else if (to.name == 'ven-formulario') {
            next({ name: 'ven-formulario-list' });
        } else if (to.name == 'formulario') {
            next({ name: 'formulario-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-formulario') {
            this.$router.push({ name: 'ven-formulario-list' });
        } else if (this.$route.name == 'serv-formulario') {
            this.$router.push({ name: 'serv-formulario-list' });
        } else if (this.$route.name == 'formulario') {
            this.$router.push({ name: 'formulario-list' });
        }
    },
};
</script>
